import { propOr } from 'ramda';
import React, { FC } from 'react';
import { isFailed, isReady, isTranscoding } from '../../../../../../utils/media-manager-sdk/transcoding';
import { ErrorOverlay, ReadyOverlay, TranscodingOverlay } from '../../../../../common/TranscodingOverlays';
import { IOuter } from './ListFileThumbnailNotReadyGuard.types';

const getThumbnailComponent = (props) => {
  const item = propOr({}, 'item', props);

  if (isTranscoding(item)) {
    return TranscodingOverlay;
  }

  if (isFailed(item)) {
    return ErrorOverlay;
  }

  if (isReady(item)) {
    return ReadyOverlay;
  }
};

export const ListFileThumbnailNotReadyGuard: FC<IOuter> = (props) => {
  const Thumbnail = getThumbnailComponent(props);

  return <Thumbnail {...props} />;
};
